import * as React from 'react'
import { signIn as nextSignIn, useSession, SessionProvider as NextSessionProvider } from 'next-auth/react'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
import { getRoute } from '../../../server/routes'
import { showDialog } from '../../../state/actions/ui/ui'
import { base64ToAscii } from '../../../util/base64ToAscii/base64ToAscii'
import { NEXT_AUTH_BASEPATH, NEXT_AUTH_SALESFORCE_CALLBACK } from './constants'
import { ParsedUrlQuery } from 'node:querystring'
import { log } from '../../../util/log'

export const signIn = () => {
  // Sign in directly to salesforce to skip auth provider selection screen
  nextSignIn('salesforce')
}

export const getNextAuthSalesforceCallbackUrl = (query: ParsedUrlQuery): string => {
  // The state param is used by next-auth to mitigate CSRF attacks (see https://auth0.com/docs/secure/attack-protection/state-parameters#set-and-compare-state-parameter-values).
  // It should not be passed to the next-auth callback
  const { state, ...queryWithoutState } = query

  return `${NEXT_AUTH_SALESFORCE_CALLBACK}?${new URLSearchParams({
    ...queryWithoutState,
    // By setting callbackUrl explicitly, prevent usage of next-auth callback cookie, which would (in some cases) redirect to location.host
    // Instead use state query if available, or redirect to /dashboard
    callbackUrl: state ? `/dashboard/api/legacytoken?state=${state}` : '/dashboard',
  }).toString()}`
}

const useHandleSessionExpiration = () => {
  const session = useSession()
  const dispatch = useDispatch()
  const router = useRouter()

  // When user is not authenticated and is on a page that requires authentication, show dialog
  React.useEffect(() => {
    if (session.status === 'unauthenticated' && getRoute(router.asPath)?.requiresAuthentication) {
      dispatch(
        showDialog({
          title: 'JE BENT UITGELOGD',
          content:
            'Klik op de knop hieronder om opnieuw in te loggen',
          primaryAction: {
            onClick: () => signIn(),
            label: 'Log opnieuw in'
          },
        }),
      )
    }
  }, [session.status, router.asPath])

  return null
}

const HandleSessionExpiration = () => {
  useHandleSessionExpiration()

  return null
}

export const SessionProvider = ({ children }) => (
  <NextSessionProvider basePath={NEXT_AUTH_BASEPATH}>
    <HandleSessionExpiration />
    {children}
  </NextSessionProvider>
)
